import { IWixAPI } from '@wix/native-components-infra/dist/src/types/types';

export function getQueryParam(wixAPI: IWixAPI, param: string) {
  return wixAPI.location.query[param];
}

export function getCurrencyHeader(wixAPI: IWixAPI): string {
  const currencyCode = getQueryParam(wixAPI, 'currency');
  return currencyCode ?? '';
}

export function getCurrentlyUsedMultilingualLanguage(wixAPI: IWixAPI) {
  const currentShortLang = wixAPI.window.multilingual.currentLanguage;
  return wixAPI.window.multilingual.siteLanguages.find(
    (lang) => lang.languageCode === currentShortLang,
  );
}
